import { render, staticRenderFns } from "./TableHeaderToolTip.vue?vue&type=template&id=54e62335&scoped=true&"
import script from "./TableHeaderToolTip.vue?vue&type=script&lang=ts&"
export * from "./TableHeaderToolTip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e62335",
  null
  
)

export default component.exports